// Detectar automáticamente el entorno
const esLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const RUTA_IMAGEN = esLocal 
    ? 'http://localhost/sistema-gimnasio/api/'
    : 'https://masterfitadmin.com/api/';

const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const Utiles = {
    generarURL(imagen) {
        if (!imagen) return "";
        return RUTA_IMAGEN + imagen;
    },

    obtenerClaves(data) {
        if (Array.isArray(data)) {
            return data.map(elemento => elemento[Object.keys(elemento)[0]]);
        } else if (typeof data === 'object' && data !== null) {
            return Object.keys(data);
        } else {
            console.error('El argumento pasado a obtenerClaves no es válido:', data);
            return [];
        }
    },

    obtenerValores(array){
        let valores = array.map(elemento => {
            return elemento.numeroVisitas
        })
        return valores
    },
    
    obtenerValoresPagos(data) {
        if (Array.isArray(data)) {
            return data.map(elemento => parseFloat(elemento.total));
        } else {
            console.error('El argumento pasado a obtenerValoresPagos no es un arreglo:', data);
            return [];
        }
    },

    cambiarDiaSemana(array){
        for(let i = 0; i < array.length; i++){
            let pos = array[i].numeroDia 
            array[i].dia = DIAS[pos-1]
            
        }
        return array
    },

    cambiarNumeroANombreMes(arreglo){
        for(let i = 0; i < arreglo.length; i++){
            let pos = arreglo[i].mes 
            arreglo[i].mes = MESES[pos-1]
            
        }
        return arreglo
    },
}

export default Utiles


// WEBPACK FOOTER //
// ./src/Servicios/Utiles.js